var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "sidebarFilter" }, [
    _c("p", { staticClass: "sidebarFilter__desc" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.trans("EXTENDED_SEARCH_ACCURACY_FILTER_DESC")) +
          "\n    "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "sidebarFilter__wrapperRadioButton" }, [
      _c("label", { staticClass: "sidebarFilter__container" }, [
        _c("input", {
          staticClass: "sidebarFilter__input",
          attrs: {
            id: "allWords",
            "data-gtm": "sidebarFilter__accuracy--all",
            type: "radio",
            tabindex: "0",
          },
          domProps: { checked: _vm.checkAccuracyAll },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.selectAccuracy(_vm.all)
            },
            click: function ($event) {
              return _vm.selectAccuracy(_vm.all)
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "sidebarFilter__radioButton" }),
        _vm._v(
          "\n            " +
            _vm._s(_vm.trans("EXTENDED_SEARCH_ACCURACY_FILTER_TEXT_ALL")) +
            "\n        "
        ),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "sidebarFilter__container" }, [
        _c("input", {
          staticClass: "sidebarFilter__input",
          attrs: {
            id: "anyWords",
            "data-gtm": "sidebarFilter__accuracy--any",
            type: "radio",
            tabindex: "0",
          },
          domProps: { checked: _vm.checkAccuracyAny },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.selectAccuracy(_vm.any)
            },
            click: function ($event) {
              return _vm.selectAccuracy(_vm.any)
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "sidebarFilter__radioButton" }),
        _vm._v(
          "\n            " +
            _vm._s(_vm.trans("EXTENDED_SEARCH_ACCURACY_FILTER_TEXT_ANY")) +
            "\n        "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }